import * as dateFns from 'date-fns';
import queryString from 'query-string';
import { SCOPE, CONTROLLER_SET, DATAOPS_ACTIONS_DICTIONARY, FILTER_KEYS } from '../../config/constants';
import { routeToSpecificScope } from '../../helpers/helpersts';

import * as eventsType from '../types';
import { SERVER } from '../../config/server.config';
import { addLoadingFlag, subLoadingFlag } from './loading';
import { changeDataOpsFetchFlag, changeActionSuccessFlag } from './flags';
import { requestData, putData } from '../../config/services/datasets';
import { cleanControllerSet } from '../../helpers/helpers';
import { changeTablePropertiesSelectedRows } from './tableProperties';
import { changeSelectedFiltersProperty } from './filters';

export const replaceDataOps = data => {
  return {
    type: eventsType.UPDATE_DATAOPS,
    data
  };
};

export const replaceDataOpsEvent = event => {
  return {
    type: eventsType.UPDATE_DATAOPS_EVENT,
    event
  };
};
//league=nfl&type=practice&teamids=*&after=20191027&before=20191126`
const specificParamBuilder = (params) => {
  const paramObject = {
    type: params.league.value.type,
    league: params.league.value.value,
    after: dateFns.format(new Date(params.dateRange.selectedDates[0].start), 'yyyyMMdd'),
    before: dateFns.format(new Date(params.dateRange.selectedDates[0].end), 'yyyyMMdd')
  };
  return queryString.stringify(paramObject, { arrayFormat: 'comma' }); // []
};

export const getDataOps = (flag) => {
  return async (dispatch, getState) => {
    // const path = getState().router.location.pathname;
    const scope = routeToSpecificScope(SCOPE.DATAOPS.ROUTES.PAGE());
    if (flag) {
      dispatch(addLoadingFlag(scope));
    }
    dispatch(changeDataOpsFetchFlag(false));
    const controller = new AbortController();
    CONTROLLER_SET.add(controller);
    let results = await requestData(SERVER.DATAOPS() + specificParamBuilder(getState().filters[scope]) + '&teamids=*', { signal: controller.signal });
    CONTROLLER_SET.delete(controller);
    if (results) {
      results = results.map(dataset => {
        return { ...dataset, status_replicaInfo: dataset.status_replicaInfo || '' };
      });
      dispatch(replaceDataOps(results));
    }
    if (flag) {

      dispatch(subLoadingFlag(scope));
    }
    dispatch(changeDataOpsFetchFlag(true));
  };
};
//league=nfl&type=practice&teamids=${teamId}&actionType=init&dataset=20191125450100
export const execAction = (practice, action) => {
  const actualAction= action && action.action ? action.action : 'init';
  const params = {
    league: practice.league,
    type: practice.type,
    teamIds: practice.home_team_id,
    actionType: actualAction,
    dataset: practice.dataset_id,

    entities: practice.targetedRetrackData ? practice.targetedRetrackData.selectedEntities : [],
    start: practice.targetedRetrackData ? new Date(practice.targetedRetrackData.startTime).getTime() : [],
    end: practice.targetedRetrackData ? new Date(practice.targetedRetrackData.endTime).getTime() : []
  };
  cleanControllerSet(CONTROLLER_SET); // to avoid having calls which could interfere with our important call
  return async dispatch => {
    const results = await requestData(SERVER.INIT_TRACK(practice.home_team_id) + queryString.stringify(params, { arrayFormat: 'comma' }));
    if (results) {
      dispatch(getDataOps());
      if (results[0].message === action.serverSuccessMessage) {
        dispatch(changeActionSuccessFlag(action, true));
        if (actualAction === DATAOPS_ACTIONS_DICTIONARY.retrackInstance.action || actualAction === DATAOPS_ACTIONS_DICTIONARY.tretrackInstance.action) {
          dispatch(changeSelectedFiltersProperty(false, FILTER_KEYS.TARGETED_RETRACK, SCOPE.DATAOPS.ENTITIES+":"+practice.game_id));
          dispatch(changeTablePropertiesSelectedRows([], undefined, SCOPE.DATAOPS.ENTITIES+":"+practice.game_id));
        }
      } else {
        // bad request, dispatch wrong flag
        dispatch(changeActionSuccessFlag(action, false));
      }
    } else {
      dispatch(changeActionSuccessFlag(action, false)); // temporary... need a more detailed response from backend
    }
  };
};

export const saveSchedule = (event) => {
  return async (dispatch, getState) => {
    const path = getState().router.location.pathname;
    const scope = routeToSpecificScope(path);
    dispatch(addLoadingFlag(scope));
    cleanControllerSet(CONTROLLER_SET);
    const results = await requestData(SERVER.PRACTICE_SCHEDULE(event.game_id));
    if (results && results[0]) {
      // eslint-disable-next-line no-unused-vars
      const putRes = await putData(SERVER.PUT_MONITOR_REVIEW_BY(event._id, event.home_team_id, event.league, event.type), {
        ...results[0],
        'dsUpdateTimeStampChange': true
      });
      if (results[0].hasOwnProperty('dataset_id') && results[0].dataset_id &&
        results[0].hasOwnProperty('dataset_ref_id') && results[0].dataset_ref_id) {

        dispatch(changeActionSuccessFlag(DATAOPS_ACTIONS_DICTIONARY.saveSchedule, true));
      }
      dispatch(subLoadingFlag(scope));
    } else {
      dispatch(subLoadingFlag(scope));
    }
  };
};


export const saveTargetedRetrack = (practice, start, end) => {
  return (dispatch, getState) => {
    const path = getState().router.location.pathname;
    const specificScope = routeToSpecificScope(path);
    const selectedEntities = getState().tableProperties[specificScope].selectedRows;
    const copyPractice = JSON.parse(JSON.stringify(practice));
    copyPractice.targetedRetrackData = {
      startTime: start,
      endTime: end,
      selectedEntities
    };
    dispatch(replaceDataOpsEvent(copyPractice));
    //history.push(SCOPE.DATAOPS.ROUTES.PAGE());
  };
};
